import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Moon, Sun, Palette } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

const ThemeSwitcher = () => {
  const { i18n } = useTranslation();
  const { mode, themeVariant, currentTheme, toggleMode, changeThemeVariant, themes } = useTheme();
  const isDe = i18n.language === 'de';

  return (
    <div className="flex items-center gap-1">
      {/* Dark/Light Mode Toggle */}
      <Button
        variant="ghost"
        size="icon"
        onClick={toggleMode}
        className="h-9 w-9 flex-shrink-0"
        title={mode === 'light' 
          ? (isDe ? 'Zu Dunkelmodus wechseln' : 'Switch to dark mode')
          : (isDe ? 'Zu Hellmodus wechseln' : 'Switch to light mode')
        }
      >
        {mode === 'light' ? (
          <Moon className="h-5 w-5" />
        ) : (
          <Sun className="h-5 w-5" />
        )}
      </Button>

      {/* Theme Variant Selector */}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button 
            variant="ghost" 
            size="icon"
            className="h-9 w-9 flex-shrink-0"
            title={isDe ? 'Theme wählen' : 'Select theme'}
          >
            <span className="text-xl">{currentTheme.icon}</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56">
          <DropdownMenuLabel>
            {isDe ? 'Theme-Stil' : 'Theme Style'}
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          
          {Object.entries(themes).map(([key, theme]) => (
            <DropdownMenuItem
              key={key}
              onClick={() => changeThemeVariant(key)}
              className={`flex items-center gap-3 cursor-pointer ${
                themeVariant === key ? 'bg-accent' : ''
              }`}
            >
              <span className="text-xl">{theme.icon}</span>
              <div className="flex-1">
                <div className="font-medium">
                  {isDe ? theme.name : theme.nameEn}
                </div>
                <div className="text-xs text-muted-foreground">
                  {isDe ? theme.description : theme.descriptionEn}
                </div>
              </div>
              {themeVariant === key && (
                <div className="h-2 w-2 rounded-full bg-primary" />
              )}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default ThemeSwitcher;
